
      <!-- Default box -->
      <div class="card card-info"  [ngClass]="{'dark-bg' : isDark }">
        <div class="card-header">Item Details</div> 
        <form [formGroup] ="itemForm" autocomplete="off" (ngSubmit)="saveButtonClick()" class="form-horizontal" enctype="multipart/form-data">
        <div class="card-body">  

        <div class="form-group row">
            <input  name="id" readonly formControlName="id"  id="id"  class="form-control"    type="hidden">
        </div>
  
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="itemCode" class="col-form-label">Item Code</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-hashtag"></i></span>
                  </div>
                  <input type="text"  [ngClass]="{'dark-input-field' : isDark }" [readonly]="isItemCodeReadOnly" formControlName="itemCode" class="form-control field-bg-color" id="itemCode" placeholder="Item Code" [class.is-invalid]="formErrors.itemCode" (blur)="logValidationErrors()">
                </div>
                <span class="text-danger" *ngIf="formErrors.itemCode"><small>{{formErrors.itemCode}}</small> </span> 
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="description" class="col-form-label">Description</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="far fa-list-alt"></i></span>
                  </div>
                  <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="description" class="form-control" id="description" placeholder="Description" [class.is-invalid]="formErrors.description" (blur)="logValidationErrors()">
                </div>
                <span class="text-danger" *ngIf="formErrors.description"><small>{{formErrors.description}}</small> </span> 
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="category" class="col-form-label">Category</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="	fa fa-bars"></i></span>
                  </div>    
                  <select  [ngClass]="{'dark-input-field' : isDark }" class="form-control" formControlName="category" id="category">
                    <option [ngValue]="null">-Select-</option>
                    <option  *ngFor="let item of itemCategoryList" [value]="item.ItemCategory">
                      {{item.ItemCategory}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
  
          <div class="row"> 
            <div class="col-md-3">
              <div class="form-group">
                <label for="reorderLevel" class="col-form-label">Unit Cost</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }">Rs.</span>
                  </div>
                  <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="unitCost" class="form-control"  placeholder="Unit Cost">
                </div>               
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="unitPrice" class="col-form-label">Unit Price</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }">Rs.</span>
                  </div>
                  <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="unitPrice" class="form-control"  placeholder="Unit Price">
                </div>               
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="reorderLevel" class="col-form-label">Re-order Level</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-line-chart"></i></span>
                  </div>
                  <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="reorderLevel" class="form-control" id="reorderLevel" placeholder="Reorder Level">
                </div>               
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="qtyBal" class="col-form-label">Qty Bal</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-line-chart"></i></span>
                  </div>
                  <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="qtyBal" class="form-control"  placeholder="Qty Bal">
                </div>               
              </div>
            </div>
          </div>
  
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <input [ngClass]="{'dark-input-field' : isDark }"  type="file" accept="image/*" formControlName="itemImage" class="form-control" (change)="onFileSelected($event)">  
               </div> 
               <img [src]="imageUrl" width="120px" height="120px">
            </div>
          </div>
  
      
        </div>
        <!-- /.card-body -->
        <div class="card-footer">
         <button type="button" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>

          <button *ngIf="crud_access.create"  type="submit"  class="btn btn-info ml-2">
           <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Save
          </button>
  
          <button class="btn btn-primary ml-2" routerLink="../item-list"><i class="fa fa-table p-1"></i>View Item List</button>
        </div>
        <!-- /.card-footer-->
        </form>
      </div>

  
